import { SvgIcon } from '../../Icon';
import styled from 'styled-components';
import { useCentralChartSettingContext } from './contexts/CentralChartSettingContext';
import { theme } from '../../../styles/theme';
import useCentralChartSettingAccordionItems from './hooks/useCentralChartSettingAccordionItems';
import Accordion from '../../Accordion/Accordion';
import { overflowingStyles } from '../../../styles/shareableStyles';

const Container = styled.div`
  width: 280px;
  border-left: 1px solid ${theme.colors.border};
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 16px;
  border-bottom: 1px solid ${theme.colors.border};
`;

const HeaderLabel = styled.div`
  color: ${theme.colors.secondary900};
  font-size: 14px;
  font-weight: 600;
`;

const ResetButton = styled.div`
  color: ${theme.colors.secondary900};
  font-size: 12px;
  font-weight: 400;
  letter-spacing: -0.12px;
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  &:hover {
    color: ${theme.colors.mainBlue};
  }
`;

const NoSettingsAvailable = styled.div`
  display: flex;
  justify-content: center;
  height: 100%;
  color: ${theme.colors.secondary900};
  font-size: 14px;
  margin-top: 120px;

  // no wrap to avoid the text change during the animation
  width: 100%;
  ${overflowingStyles}
`;

const CentralChartSetting = () => {
  const { onCentralChartSettingReset } = useCentralChartSettingContext();

  const accordionItems = useCentralChartSettingAccordionItems();

  return (
    <Container>
      <Header>
        <HeaderLabel>Chart Settings</HeaderLabel>
        <ResetButton onClick={onCentralChartSettingReset}>
          <span>Reset</span>
          <SvgIcon
            width={16}
            height={16}
            name="arrow-counter-clockwise"
            fill="currentColor"
          />
        </ResetButton>
      </Header>
      {accordionItems.length > 0 ? (
        accordionItems.map((item) => (
          <Accordion key={item.title} title={item.title}>
            {item.children}
          </Accordion>
        ))
      ) : (
        <NoSettingsAvailable>
          No settings available for this chart type
        </NoSettingsAvailable>
      )}
    </Container>
  );
};

export default CentralChartSetting;
